import toInteger from 'lodash/toInteger';

export const MoneyHelper = {
  fromBigInt(value: bigint, round: "up" | "down") {
    const preRound = Math.trunc(Number(value / BigInt(1000)));
    const fraction = Number(value % BigInt(1000));

    if (round === "up") {
      return fraction >= 500 ? preRound + 1 : preRound;
    }
    return preRound;
  },
};

export const SafeBigInt = {
  /**
    Converts decimal value to BigInt. 
    Used to preserve the value for digits after comma
  */
  fromDecimal(value: number): bigint {
    return BigInt(toInteger(value * 1000));
  },
  /**
    Returns value in a BigInt format
  */
  fromInteger(value: number): bigint {
    return BigInt(toInteger(value));
  },
};
